import { useTranslation } from 'react-i18next';
import { PublicCtaButtons } from '../PublicCtaButtons';
import { HomeChaosOrder } from './HomeChaosOrder';

export function HomeHero() {
  const { t } = useTranslation();

  return (
    <section className="relative">
      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 pt-12 pb-12 sm:pt-20 sm:pb-16">
        <div className="mx-auto max-w-3xl space-y-6 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-violet-200 bg-violet-50 px-3 py-1 text-xs font-medium text-violet-700 dark:border-violet-500/30 dark:bg-violet-500/10 dark:text-violet-200">
            <span className="h-1.5 w-1.5 rounded-full bg-violet-500 shadow-[0_0_10px_#8b5cf6] dark:bg-violet-400" />
            {t('home.hero.eyebrow')}
          </span>
          <h1 className="font-display text-[2.6rem] font-bold leading-[1.03] tracking-[-0.025em] text-zinc-900 sm:text-6xl md:text-7xl dark:text-zinc-50">
            {t('home.hero.titleLead')}
            <span className="brand-text">{t('home.hero.titleHighlight')}</span>
          </h1>
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-zinc-600 sm:text-xl dark:text-zinc-400">
            {t('home.hero.subtitle')}
          </p>
          <div className="pt-2">
            <PublicCtaButtons />
          </div>
        </div>

        {/* Transformation showcase: chaos → AI → organized */}
        <div className="mt-14 sm:mt-20">
          <HomeChaosOrder />
        </div>
      </div>
    </section>
  );
}
